import React, { useState } from "react";
import Steps from "./Steps";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";

function CheckinSteps({ catchStep }) {
  return (
    <div>
      <>
        <Steps catchStep={catchStep} />
        <Outlet />
      </>
    </div>
  );
}

export default CheckinSteps;
